<template>
	<div class="parts-locations-signature-card">
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice</h4>
			</template>
			<template #content>
				<ul>
					<li>Capture Message</li>
					<li>Methops</li>
				</ul>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'PartsLocationsSignatureCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.parts-locations-signature-card {
	&__item {
		display: block;
	}
}
</style>
